"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pontedassio": {
    "94d973eb": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "skipSearch": false
    }],
    "ca": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8661eafd": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-di-villa-viani": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "266ffc40": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "05ef22b2",
      "slug": "pontedassio",
      "name": "Pontedassio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1898896a": [{
      "hkey": "54eebdb8",
      "slug": "villa-guardia-villa-viani",
      "name": "Villa Guardia-Villa Viani",
      "primary": true,
      "skipSearch": false
    }],
    "villa-guardia": [{
      "hkey": "54eebdb8",
      "slug": "villa-guardia-villa-viani",
      "name": "Villa Guardia-Villa Viani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pontedassio"
    }],
    "c379cab5": [{
      "hkey": "54eebdb8",
      "slug": "villa-guardia-villa-viani",
      "name": "Villa Guardia-Villa Viani",
      "primary": true,
      "skipSearch": false
    }],
    "villa-viani": [{
      "hkey": "54eebdb8",
      "slug": "villa-guardia-villa-viani",
      "name": "Villa Guardia-Villa Viani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pontedassio"
    }]
  }
};
exports["default"] = _default;